import React from "react";
import { compose } from "redux";
import { withTimezone } from "../Timezone";
import { withGate } from "../Gate";
import Modal, { CloseBtn, withModal } from "../Modal";
import TimezoneList from "../TimezoneList";
import TextBtn from "../Buttons/Text";
import FullBtn from "../Buttons/Full";
import cx from "../../utils/cx";
import Loader from "react-loader-spinner";
import { persistTimezone } from "../../store/user";

const TimezoneListWithUser = withGate(TimezoneList, "_id");

const ZoneSelect = ({
  loading,
  changed,
  timezone,
  timestamp,
  getCurrentTimestamp,
  getCurrentDate,
  updateTimezone,
  saveTimezone,
  getFormattedDate,
  open,
  closeModal,
  openModal
}) => (
  <div>
    <Modal open={open} onClose={closeModal} scale={false} fadeUp={false}>
      <div
        className="position-relative bg-white shadow-lg"
        style={{ height: 540, overflow: "hidden" }}
      >
        <CloseBtn onClick={closeModal} />
        <h5 className="bold px-4 py-2 m-0">Change your time</h5>
        {open && (
          <TimezoneList
            className="position-relative"
            style={{ height: 420 }}
            timezone={timezone}
            timestamp={timestamp}
            updateTimezone={updateTimezone}
          />
        )}
        <FullBtn
          fontSize={18}
          className="position-relative text-white bg-blue bold py-2"
          onClick={() => {
            saveTimezone();
            closeModal();
          }}
          disabled={!changed}
        >
          Done
        </FullBtn>
      </div>
    </Modal>
    <div className="border-bottom pl-4 pr-2 pt-4 pb-1">
      <h5 className="bold mb-1">Timezone:</h5>
      <div className="mb-1 d-flex">
        {!loading && (
          <p className="m-0">
            Your current time is {getFormattedDate(getCurrentDate())}
          </p>
        )}
        {!loading && (
          <TextBtn onClick={openModal} className="ml-auto text-blue m-0 bold">
            Change
          </TextBtn>
        )}
        {loading && (
          <TextBtn className="ml-auto text-blue m-0 bold">
            <Loader
              type="Circles"
              color="currentColor"
              height="1em"
              width="3em"
            />
          </TextBtn>
        )}
      </div>
    </div>
  </div>
);

export default compose(
  withTimezone,
  withModal
)(ZoneSelect);



// WEBPACK FOOTER //
// ./src/components/ZoneSelect/ZoneSelect.js